import { createAsyncThunk } from '@reduxjs/toolkit';
import { UserGroupRoleMembership } from 'common/types/Entities';

import { handleListFetch } from '../apiHelpers';

import { APIUserGroupRoleGetList, APIUserGroupRoleMembershipDelete,APIUserGroupRolePost } from './UserGroupRoleMembership.api';

export const fetchUserGroupRoleMembershipList = createAsyncThunk('user-groups/fetchUserGroupRoleMembershipList', async (item: {tenantId: string, roleId: string, signal?: AbortSignal}) => {
    const response = await APIUserGroupRoleGetList(item);
    return _formatUserGroupRoleMembershipRows(response.data);
});

export const postUserGroupRoleMembership = createAsyncThunk('user-groups/postRoleUserGroup', async (item: { tenantId: string, roleId: string, userGroupId: string }) => {
    const response = await APIUserGroupRolePost(item);
    const rows = await handleListFetch(APIUserGroupRoleGetList({ tenantId: item.tenantId, roleId: item.roleId }));
    return {
        response,
        rows: _formatUserGroupRoleMembershipRows(rows)
    };
});

export const deleteUserGroupRoleMembership = createAsyncThunk(
    'user-groups/deleteUserGroupRoleMembership',
    async (item: { tenantId: string, roleId: string, userGroupId: string }) => {
        const response = await APIUserGroupRoleMembershipDelete(item);
        const { tenantId, roleId } = item;
        const rows = await handleListFetch(APIUserGroupRoleGetList({ tenantId, roleId }));
        return {
            response,
            rows: _formatUserGroupRoleMembershipRows(rows)
        };
    }
);

const _formatUserGroupRoleMembershipRows = (rows: UserGroupRoleMembership[]) => (
    rows.map(item => ({
        ...item,
        id: item.userGroupId,
        name: item.userGroupName,
        description: item.userGroupDescription,
    }))
);
